import {Tariff} from "./tariff";
import {TariffTier} from "./tariff-tier";

export class TaxiTariff {
  tariff: Tariff;
  tier: TariffTier;
}
